import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { useLanguage } from '@components/context/language';
import { getTranslation } from '../../translations';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--john-text-pretty);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const { language } = useLanguage();
  const revealContainer = useRef(null);
  useEffect(() => sr.reveal(revealContainer.current, srConfig()), []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">{getTranslation(language, 'contact.overline')}</h2>

      <h2 className="title">{getTranslation(language, 'contact.title')}</h2>

      <p>{getTranslation(language, 'contact.description')}</p>

      <a className="email-link shimmer-link" href={`mailto:${email}`}>
        {getTranslation(language, 'contact.button')}
      </a>
    </StyledContactSection>
  );
};

export default Contact;
